import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expense_13whb",
  "use": "expense_13whb-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"expense_13whb\">\n    <polyline points=\"4,16 10,10 14,14 20,8 20,14, 14,14\" stroke=\"currentColor\" fill=\"none\" strokeWidth=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol